/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ArtistIdCollectionRunStatus
 */
export interface ArtistIdCollectionRunStatus {
    /**
     * 
     * @type {string}
     * @memberof ArtistIdCollectionRunStatus
     */
    runId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArtistIdCollectionRunStatus
     */
    status: ArtistIdCollectionRunStatusStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ArtistIdCollectionRunStatus
     */
    phase?: ArtistIdCollectionRunStatusPhaseEnum;
    /**
     * 
     * @type {string}
     * @memberof ArtistIdCollectionRunStatus
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArtistIdCollectionRunStatus
     */
    sourceId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistIdCollectionRunStatus
     */
    isStalled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ArtistIdCollectionRunStatus
     */
    errorDetail?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ArtistIdCollectionRunStatus
     */
    requestedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ArtistIdCollectionRunStatus
     */
    lastProgressAt?: Date | null;
}


/**
 * @export
 */
export const ArtistIdCollectionRunStatusStatusEnum = {
    Queued: 'QUEUED',
    NotStarted: 'NOT_STARTED',
    Managed: 'MANAGED',
    Starting: 'STARTING',
    Started: 'STARTED',
    Success: 'SUCCESS',
    Failure: 'FAILURE',
    Canceling: 'CANCELING',
    Canceled: 'CANCELED'
} as const;
export type ArtistIdCollectionRunStatusStatusEnum = typeof ArtistIdCollectionRunStatusStatusEnum[keyof typeof ArtistIdCollectionRunStatusStatusEnum];

/**
 * @export
 */
export const ArtistIdCollectionRunStatusPhaseEnum = {
    Launching: 'LAUNCHING',
    Starting: 'STARTING',
    Running: 'RUNNING',
    Succeeded: 'SUCCEEDED',
    Failed: 'FAILED',
    Cancelling: 'CANCELLING',
    Cancelled: 'CANCELLED'
} as const;
export type ArtistIdCollectionRunStatusPhaseEnum = typeof ArtistIdCollectionRunStatusPhaseEnum[keyof typeof ArtistIdCollectionRunStatusPhaseEnum];


/**
 * Check if a given object implements the ArtistIdCollectionRunStatus interface.
 */
export function instanceOfArtistIdCollectionRunStatus(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "runId" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function ArtistIdCollectionRunStatusFromJSON(json: any): ArtistIdCollectionRunStatus {
    return ArtistIdCollectionRunStatusFromJSONTyped(json, false);
}

export function ArtistIdCollectionRunStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistIdCollectionRunStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'runId': json['run_id'],
        'status': json['status'],
        'phase': !exists(json, 'phase') ? undefined : json['phase'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'sourceId': !exists(json, 'source_id') ? undefined : json['source_id'],
        'isStalled': !exists(json, 'is_stalled') ? undefined : json['is_stalled'],
        'errorDetail': !exists(json, 'error_detail') ? undefined : json['error_detail'],
        'requestedAt': !exists(json, 'requested_at') ? undefined : (json['requested_at'] === null ? null : new Date(json['requested_at'])),
        'lastProgressAt': !exists(json, 'last_progress_at') ? undefined : (json['last_progress_at'] === null ? null : new Date(json['last_progress_at'])),
    };
}

export function ArtistIdCollectionRunStatusToJSON(value?: ArtistIdCollectionRunStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'run_id': value.runId,
        'status': value.status,
        'phase': value.phase,
        'source': value.source,
        'source_id': value.sourceId,
        'is_stalled': value.isStalled,
        'error_detail': value.errorDetail,
        'requested_at': value.requestedAt === undefined ? undefined : (value.requestedAt === null ? null : value.requestedAt.toISOString()),
        'last_progress_at': value.lastProgressAt === undefined ? undefined : (value.lastProgressAt === null ? null : value.lastProgressAt.toISOString()),
    };
}

